import * as ERRORES from "../../config/constants/step-constants";

const Facebook = {
  enable() {
    !(function(f, b, e, v, n) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  paso1() {
    window.fbq("track", "Search", { content_type: "Emprendedores" });
  },
  paso2() {
    window.fbq("track", "AddToCart", { content_type: "Emprendedores" });
  },
  paso3() {
    window.fbq("track", "Lead", { content_type: "Emprendedores" });
  },
  paso4() {
    window.fbq("track", "InitiateCheckout", {
      content_type: "Emprendedores"
    });
  },
  gracias() {
    window.fbq("track", "Purchase", { content_type: "Emprendedores" });
  },
  mensaje(context) {
    switch (context.mutation.payload.params.mje) {
      case ERRORES.ERROR_TECNICO:
        window.fbq("track", "CompleteRegistration", {
          content_type: "Emprendedores"
        });
        break;
      case ERRORES.INDIVIDUO_NEGATIVO:
        window.fbq("track", "AddToWishlist", {
          content_type: "Emprendedores"
        });
        break;
    }
  }
};

export default Facebook;
